import React from 'react';
import { motion } from 'framer-motion';
export function PhilosophySection() {
  const statements = ['Selective by design.', 'Conviction over consensus.', 'Long-term perspective.'];
  return <section className="py-32 md:py-48 px-6 flex flex-col items-center justify-center" data-id="element-47">
      <div className="w-full max-w-4xl flex flex-col items-center space-y-24 md:space-y-32" data-id="element-48">
        {statements.map((statement, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: index * 0.15
      }} className="text-center" data-id="element-49">
            <h2 className="font-heading text-2xl md:text-4xl text-brand-offWhite font-light uppercase tracking-widest" data-id="element-50">
              {statement}
            </h2>
          </motion.div>)}
      </div>
    </section>;
}